import { firebaseConnection } from '@/library/firebase'
import moment from 'moment'
export default {
  directives: {
    convertTime: {
      bind: (el, binding, vnode) => {
        vnode.elm.innerText = moment
          .unix(binding.value)
          .utc()
          .format('MMMM Do YYYY, h:mm:ss a')
      }
    },
    imageLoading: {
      bind: (el, binding, vnode) => {
        const image = new Image()
        if (!binding.value.startsWith('http')) {
          vnode.elm.src = require('../assets/images/common/loading-1.gif')
          vnode.elm.style.width = '60px'
          vnode.elm.style.height = '60px'
          // vnode.elm.style.objectFit = 'contain'

          if (
            typeof binding.value !== 'undefined' &&
            typeof binding.value === 'string'
          ) {
            firebaseConnection
              .storage()
              .ref(binding.value)
              .getDownloadURL()
              .then(url => {
                image.onload = e => {
                  vnode.elm.src = e.target.src
                  vnode.elm.style.width = ''
                  vnode.elm.style.height = ''
                  // vnode.elm.style.objectFit = 'contain'
                  // vnode.elm.style.opacity = 0
                  // const timeLoop = setInterval(() => {
                  //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                  //         clearInterval(timeLoop)
                  //     } else {
                  //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
                  //     }
                  // }, 30)
                }
                image.src = url
              })
          } else {
            image.onload = e => {
              vnode.elm.style.width = ''
              vnode.elm.src = e.target.src
              // vnode.elm.style.opacity = 0
              // const timeLoop = setInterval(() => {
              //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
              //         clearInterval(timeLoop)
              //     } else {
              //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
              //     }
              // }, 30)
            }
            image.src = binding.value
          }
        } else {
          image.onload = e => {
            vnode.elm.src = e.target.src
            vnode.elm.style.width = ''
            vnode.elm.style.height = ''
            // vnode.elm.style.objectFit = 'contain'
            // vnode.elm.style.opacity = 0
            // const timeLoop = setInterval(() => {
            //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
            //         clearInterval(timeLoop)
            //     } else {
            //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
            //     }
            // }, 30)
          }
          image.src = binding.value
        }
      },
      update: (el, binding, vnode) => {
        // console.log('binding.oldValue !== binding.value:', binding.oldValue, binding.value)
        const image = new Image()
        if (
          typeof binding.value !== 'undefined' &&
          binding.oldValue !== binding.value
        ) {
          // console.log('update: ', binding.value)
          firebaseConnection
            .storage()
            .ref(binding.value)
            .getDownloadURL()
            .then(url => {
              image.onload = e => {
                vnode.elm.src = e.target.src
                // vnode.elm.style.opacity = 0
                // const timeLoop = setInterval(() => {
                //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                //         clearInterval(timeLoop)
                //     } else {
                //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
                //     }
                // }, 30)
              }
              image.src = url
            })
        } else {
          image.onload = e => {
            vnode.elm.src = e.target.src
            // vnode.elm.style.opacity = 0
            // const timeLoop = setInterval(() => {
            //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
            //         clearInterval(timeLoop)
            //     } else {
            //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
            //     }
            // }, 30)
          }
          image.src = binding.value
        }
      }
    },
    imageServiceLoading: {
      bind: (el, binding, vnode) => {
        // console.log('bind', binding.value)
        const image = new Image()
        vnode.elm.src = require('../assets/images/common/loading-1.gif')
        // vnode.elm.style.width = '60px'
        if (
          typeof binding.value !== 'undefined' &&
          typeof binding.value === 'string'
        ) {
          firebaseConnection
            .storage()
            .ref(binding.value)
            .getDownloadURL()
            .then(url => {
              image.onload = e => {
                vnode.elm.src = e.path[0].src
                // vnode.elm.style.objectFit = 'contain'
                // vnode.elm.style.opacity = 0
                // const timeLoop = setInterval(() => {
                //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                //         clearInterval(timeLoop)
                //     } else {
                //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
                //     }
                // }, 30)
              }
              image.src = url
            })
        } else {
          image.onload = e => {
            vnode.elm.src = e.path[0].src
            // vnode.elm.style.opacity = 0
            // const timeLoop = setInterval(() => {
            //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
            //         clearInterval(timeLoop)
            //     } else {
            //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
            //     }
            // }, 30)
          }
          image.src = binding.value
        }
      },
      update: (el, binding, vnode) => {
        // console.log('binding.oldValue !== binding.value:', binding.oldValue, binding.value)
        const image = new Image()
        if (
          typeof binding.value !== 'undefined' &&
          binding.oldValue !== binding.value
        ) {
          // console.log('update: ', binding.value)
          firebaseConnection
            .storage()
            .ref(binding.value)
            .getDownloadURL()
            .then(url => {
              image.onload = e => {
                vnode.elm.src = e.path[0].src
                // vnode.elm.style.opacity = 0
                // const timeLoop = setInterval(() => {
                //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                //         clearInterval(timeLoop)
                //     } else {
                //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
                //     }
                // }, 30)
              }
              image.src = url
            })
        } else {
          image.onload = e => {
            vnode.elm.src = e.path[0].src
            // vnode.elm.style.opacity = 0
            // const timeLoop = setInterval(() => {
            //     if (parseFloat(vnode.elm.style.opacity) > 0.9) {
            //         clearInterval(timeLoop)
            //     } else {
            //         vnode.elm.style.opacity = parseFloat(vnode.elm.style.opacity) + 0.1
            //     }
            // }, 30)
          }
          image.src = binding.value
        }
      }
    },
    fadeInImageLoading: {
      bind: (el, binding, vnode) => {
        // console.log('bind', binding.value)
        const image = new Image()
        // vnode.elm.src = require('../assets/images/landing/UDui.gif')
        // vnode.elm.style.width = '100px'
        // vnode.elm.style.height = '100px'
        // vnode.elm.style.objectFit = 'cover'
        if (
          typeof binding.value !== 'undefined' &&
          typeof binding.value === 'string'
        ) {
          firebaseConnection
            .storage()
            .ref(binding.value)
            .getDownloadURL()
            .then(url => {
              image.onload = e => {
                // console.log('image loading: ', e)
                vnode.elm.style.width = ''
                vnode.elm.style.height = ''
                vnode.elm.style.objectFit = ''
                vnode.elm.src = e.target.src
                vnode.elm.style.opacity = 0
                const timeLoop = setInterval(() => {
                  if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                    clearInterval(timeLoop)
                  } else {
                    vnode.elm.style.opacity =
                      parseFloat(vnode.elm.style.opacity) + 0.1
                  }
                }, 50)
              }
              image.src = url
            })
        } else {
          image.onload = e => {
            // console.log('chagne:', e)
            vnode.elm.src = e.target.src
            vnode.elm.style.width = ''
            vnode.elm.style.height = ''
            vnode.elm.style.objectFit = ''
            vnode.elm.style.border = 'none'
            vnode.elm.style.opacity = 0
            const timeLoop = setInterval(() => {
              if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                clearInterval(timeLoop)
              } else {
                vnode.elm.style.opacity =
                  parseFloat(vnode.elm.style.opacity) + 0.1
              }
            }, 50)
          }
          image.src = binding.value
        }
      },
      update: (el, binding, vnode) => {
        // console.log('binding.oldValue !== binding.value:', binding.oldValue, binding.value)
        const image = new Image()
        if (
          typeof binding.value !== 'undefined' &&
          binding.oldValue !== binding.value
        ) {
          // console.log('update: ', binding.value)

          const fadeOut = setInterval(() => {
            if (parseFloat(vnode.elm.style.opacity) > 0.9) {
              clearInterval(fadeOut)
            } else {
              vnode.elm.style.opacity =
                parseFloat(vnode.elm.style.opacity) + 0.2
            }
          }, 50)

          firebaseConnection
            .storage()
            .ref(binding.value)
            .getDownloadURL()
            .then(url => {
              image.onload = e => {
                vnode.elm.src = e.target.src
                vnode.elm.style.border = 'none'
                vnode.elm.style.opacity = 0
                const timeLoop = setInterval(() => {
                  if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                    clearInterval(timeLoop)
                  } else {
                    vnode.elm.style.opacity =
                      parseFloat(vnode.elm.style.opacity) + 0.1
                  }
                }, 50)
              }
              image.src = url
            })
        } else {
          image.onload = e => {
            vnode.elm.src = e.target.src
            vnode.elm.style.border = 'none'
            vnode.elm.style.opacity = 0
            const timeLoop = setInterval(() => {
              if (parseFloat(vnode.elm.style.opacity) > 0.9) {
                clearInterval(timeLoop)
              } else {
                vnode.elm.style.opacity =
                  parseFloat(vnode.elm.style.opacity) + 0.1
              }
            }, 50)
          }
          image.src = binding.value
        }
      }
    }
  }
}
